async function fetchWithRetry(asyncFunc: () => Promise<any>, retryMax: number, timeout: number) {
    let retryCount = 0;

    while (retryCount < retryMax) {
        try {
            const result = await asyncFunc();
            return result;
        } catch (error: any) {
            if (retryCount < retryMax - 1) {
                retryCount++;
                console.error(error);
                await new Promise((resolve) => setTimeout(resolve, timeout));
            } else {
                return Promise.reject(error);
            }
        }
    }
}

export const retriesProvider = {
    fetchWithRetry,
};
